import { useContext, useEffect, useState } from 'react'
import AppBodyComponent from '../Components/AppBodyComponent'
import AuthContext from '../Contexts/AuthContext'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { updateRegisterPlaceService } from '../Service/UserService';

function AppHome() {
    const {userAuth, setUserAuth} = useContext(AuthContext)
    const { t } = useTranslation('app_home');
    const navigate = useNavigate()

    
    const accept = () => {
        updateRegisterPlaceService(userAuth?.user?.access_key, true).then(res=>{
            if (res && userAuth?.user){
                let _userAuth = {...userAuth}
                _userAuth.user.register_place = res
                setUserAuth(_userAuth)
            } 
        })
        navigate('/app/register_place')
    }

    const reject = () => {
        updateRegisterPlaceService(userAuth?.user?.access_key, true).then(res=>{
            if (res && userAuth?.user){
                let _userAuth = {...userAuth}
                _userAuth.user.register_place = res
                setUserAuth(_userAuth)
            } 
        })
    }


    const handleDialogRegisterPlace = () => {
        userAuth?.user?.register_place === 0 && 
        confirmDialog({
            message: t('add_register_place'),
            header: t('confirmation'),
            icon: 'pi pi-question-circle',
            defaultFocus: 'accept',
            accept,
            reject
        });
    };

    useEffect(()=>{
        handleDialogRegisterPlace()
    },[userAuth?.user?.register_place])

    
    return (
        <AppBodyComponent>
            <ConfirmDialog />
        </AppBodyComponent>
    )
}

export default AppHome